import { LandingPage } from "./Landing";
import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "./components/auth-wrapper/useAuth";

/**
 * A component that wraps the react-router route so we can lock off pages that need authentication.
 */
const ProtectedRoute: FC = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Outlet /> : <LandingPage />;
};

export default ProtectedRoute;
